export default __webpack_public_path__ + "static/N0189-5043ebfd9181fd239aa28d7bc4c3b33f.png";